module.exports = __webpack_public_path__ + "media/images/emblems/Gimel-coat_of_arms-25990ba1739f2f53e8e57e264bd38921.svg";